<template>
  <section v-if="items.length" class="search-course-panel">
    <div class="search-course__header">
      <span>Resultados encontrados</span>
      <strong>{{ items.length }} experiencias listas para explorar</strong>
    </div>

    <div class="search-course__track">
      <button
        v-for="course in items"
        :key="course.id"
        class="search-course__item"
        type="button"
        @click="showDetail(course)"
      >
        <img v-if="imageUrl(course)" :src="imageUrl(course)" :alt="course.name" loading="lazy" @error="markImageError(course)" />
        <div v-else class="search-course__placeholder">{{ placeholderMark(course) }}</div>
        <div class="search-course__name">{{ course.name }}</div>
        <div class="search-course__meta">{{ course.venue && course.venue.city ? course.venue.city.name : 'Evento destacado' }}</div>
      </button>
    </div>
  </section>
</template>

<script>
export default {
  name: 'SearchCourse',

  props: {
    courses: {
      type: [Array, Object],
      required: false,
      default: () => [],
    },
  },

  computed: {
    items() {
      if (Array.isArray(this.courses)) {
        return this.courses
      }

      if (this.courses && Array.isArray(this.courses.results)) {
        return this.courses.results
      }

      return []
    },
  },

  data() {
    return {
      failedImages: {},
    }
  },

  methods: {
    imageKey(course) {
      return course.slug || course.id || course.name
    },

    resolveMediaCandidates(value) {
      if (!value) {
        return []
      }

      const origin = window.location.origin
      const localBackendCandidates = ['http://127.0.0.1:8000', 'http://localhost:8000']
      const normalizePath = (candidate) => candidate
        .replace(/^\/media\//, '')
        .replace(/^.*\/media\//, '')
        .replace(/^media\//, '')
        .replace(/^\//, '')

      if (value.startsWith('data:') || value.startsWith('blob:')) {
        return [value]
      }

      if (/^https?:\/\//i.test(value)) {
        try {
          const parsed = new URL(value)

          if (!parsed.pathname.includes('/media/')) {
            return [value]
          }

          const normalizedPath = normalizePath(parsed.pathname)

          return [...new Set([
            value,
            `${origin}/media/${normalizedPath}`,
            ...localBackendCandidates.map((base) => `${base}/media/${normalizedPath}`),
            `https://gingopolisdjango.blob.core.windows.net/fomoapp/media/${normalizedPath}`,
          ])]
        } catch (error) {
          return [value]
        }
      }

      const normalizedPath = normalizePath(value)

      if (value.startsWith('/media/') || value.startsWith('media/') || !value.startsWith('/')) {
        return [...new Set([
          `${origin}/media/${normalizedPath}`,
          ...localBackendCandidates.map((base) => `${base}/media/${normalizedPath}`),
          `https://gingopolisdjango.blob.core.windows.net/fomoapp/media/${normalizedPath}`,
        ])]
      }

      return [`${origin}${value}`]
    },

    imageCandidates(course) {
      return [course.banner_url, course.image_url, course.cover_url, course.thumbnail]
        .filter(Boolean)
        .flatMap((value) => this.resolveMediaCandidates(value))
    },

    imageUrl(course) {
      const failed = this.failedImages[this.imageKey(course)] || []
      return this.imageCandidates(course).find((candidate) => !failed.includes(candidate)) || ''
    },

    placeholderMark(course) {
      const source = course && course.name ? course.name.trim() : 'FP'
      return source.slice(0, 2).toUpperCase()
    },

    markImageError(course) {
      const key = this.imageKey(course)
      const failed = this.failedImages[key] || []
      const activeImage = this.imageUrl(course)

      this.failedImages = {
        ...this.failedImages,
        [key]: activeImage ? [...failed, activeImage] : failed,
      }
    },

    showDetail(course) {
      if (course.access === 4) {
        this.$router.push({ name: 'host', params: { host: course.slug } })
      } else {
        this.$router.push({ name: 'event', params: { slug: course.slug } })
      }
    },
  },
}
</script>

<style>
.search-course__item {
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
}

.search-course__placeholder {
  width: 100%;
  height: 132px;
  display: grid;
  place-items: center;
  border-radius: 16px;
  font-size: 1.1rem;
  font-weight: 800;
}
</style>
